/*
========================================================================||
Scroll To Module
- Scrolls to element on button/anchor elements on click
- Target can be defined by href or [data-scroll-to] attribute
  Note: Attribute target ID takes precedence over href

Usage:
<button type="button" class="js-scroll-to" data-scroll-to="id"></button>
<a href="#id" class="js-scroll-to"></a>
<button type="button" class="js-scroll-to"></button>
========================================================================||
*/

import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

import { BODY, WINDOW } from '../helpers/browser';
import { getConfig } from '../helpers/tailwind';

function calculateScrollOffset(targetElement) {
  // targetElementOffsetTop with getBoundingClientRect() only returns top offset based of window viewport
  // add it with WINDOW.pageYOffset to get offset top with respect to the whole page (excl viewport)
  const targetElementOffsetTop = targetElement.getBoundingClientRect().top;
  const currentScrollTop = WINDOW.pageYOffset;

  let offsetTop = 0;

  // add offset top for header-main
  offsetTop +=
    WINDOW.innerWidth >= getConfig('screens.lg', 'px')
      ? getConfig('height.header-main-desktop', 'px')
      : getConfig('height.header-main-mobile', 'px');

  // if (currentScrollTop > targetElementOffsetTop + WINDOW.pageYOffset) {
  if (currentScrollTop < 40) {
    // if reach here, scroll is going up
    // thus header would not be shrinked

    // add header-top height to offset
    offsetTop +=
      WINDOW.innerWidth >= getConfig('screens.lg', 'px')
        ? getConfig('height.header-top-desktop', 'px')
        : 0;
  }

  // if reach here, scroll is going down
  // thus header would be shrinked
  return targetElementOffsetTop + WINDOW.pageYOffset - offsetTop;
}

export class ScrollTo {
  constructor(el, settings = {}) {
    this.el = el;
    this.settings = settings;

    this.init();
  }

  init() {
    this.targetId = this.getTargetId();

    if (this.targetId) {
      this.targetElement = BODY.querySelector(`#${this.targetId}`);

      if (this.targetElement || this.targetId === 'back-to-top') {
        this.el.addEventListener('click', this.clickHandler);
      }
    }
  }

  // looks for [data-scroll-to] attribute first
  // if not found, looks for el.id
  // defaults to #form

  getTargetId = () => {
    if (this.el.hasAttribute('data-scroll-to')) {
      if (this.el.dataset.scrollTo === 'back-to-top') {
        return 'back-to-top';
      }

      if (BODY.querySelector(`#${this.el.dataset.scrollTo}`)) {
        return this.el.dataset.scrollTo;
      }
    } else if (this.el.hash) {
      if (
        BODY.querySelector(this.el.hash) ||
        this.el.hash.substring(1) === 'back-to-top'
      ) {
        return this.el.hash.substring(1);
      }
    }

    if (BODY.querySelector('#form')) {
      return 'form';
    }

    return '';
  };

  clickHandler = e => {
    e.preventDefault();

    WINDOW.scroll({
      top:
        this.targetId === 'back-to-top'
          ? 0
          : calculateScrollOffset(this.targetElement),
      left: 0,
      behavior: 'smooth',
    });
  };
}

export default function() {
  const scrollers = Array.from(BODY.querySelectorAll('.js-scroll-to'));

  if (scrollers.length) {
    scrollers.forEach(el => {
      el.instance = new ScrollTo(el);
    });
  }
}

export function scrollToTarget(targetId, offset = 0) {
  if (!targetId.includes('/') && BODY.querySelector(`#${targetId}`)) {
    const targetElement = BODY.querySelector(`#${targetId}`);
    const top =
      targetId === 'back-to-top' ? 0 : calculateScrollOffset(targetElement);

    WINDOW.scroll({
      top: offset ? top - offset : top,
      left: 0,
      behavior: 'smooth',
    });
  }
}

export function getScrollOffset(targetId) {
  if (!targetId.includes('/') && BODY.querySelector(`#${targetId}`)) {
    const targetElement = BODY.querySelector(`#${targetId}`);

    return calculateScrollOffset(targetElement);
  }

  return -1;
}
